import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-preparation-item-report-folder.controller';
import directive from './attach-preparation-item-report-folder.directive';


export default angular.module('app.components.advisory.auditTrail.attachPreparationItemReportFolder', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amAttachPreparationItemReportFolder', directive)
  .controller('AttachPreparationItemReportFolderController', controller)
  .name;

console.log('app.components.advisory.auditTrail.attachPreparationItemReportFolder created');
